export const formatINR = (n) =>
  n == null || n === ""
    ? "—"
    : new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);

export const formatSqft = (n) => (n == null ? "—" : `${new Intl.NumberFormat("en-IN").format(n)} sqft`);

export const sizeOf = (p) =>
  p.saleable_area_sqft
    ? `${formatSqft(p.saleable_area_sqft)} (saleable)`
    : p.carpet_area_sqft
    ? `${formatSqft(p.carpet_area_sqft)} (carpet)`
    : p.plot_area_sqft
    ? `${formatSqft(p.plot_area_sqft)} (plot)`
    : "—";

export const mediaUrl = (u) => (u?.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`);

export const yesNo = (v) => (v == null ? "—" : v ? "Yes" : "No");
